import router from './router';
import util from '../utils/util';
import nmcConfig from '../config/config';

/**
 * 页面管理
 * @class pageManager
 * @static
 */
var pageManager = {
  loadCommon: function () {
    var _self = this,
      arr = [].slice.call(arguments); //解析路由匹配
    this.parseMatch(arr, function (controller, action, params) {
      //处理路由, 加载视图
      params = params || [];
      _self.loadView(controller, action, params);
    });
  },
  parseMatch: function (arr, cb) {
    var controller = null,
      action = null,
      params = []; //获取controller
    controller = arr[0]; //获取action与params

    if (arr.length > 1) {
      if (_typeof(arr[1]) === 'object') {
        params.push(arr[1]);
      } else {
        action = arr[1];
        params = arr.slice(2);
      }
    }
    cb(controller, 'index', params);
  },
  tryIframeRouter: function () { },
  loadView: function (controller, action, params) {
    var basePath = 'modules/',
      _self = this;
    var controllerId = basePath + controller + '/' + controller,
      actionId = basePath + controller + '/' + action + '/' + action;
    var moduleArr = []; //检查是否存在controller模块
    if (seajs.hasDefined[controllerId]) {
      moduleArr.push(controllerId);
    } else {
      controllerId = '';
    } //检查是否存在action模块

    if (action) {
      if (!seajs.hasDefined[actionId]) {
        return _self.tryIframeRouter(controller);
      }

      moduleArr.push(actionId);
    } else {
      // 未指明action，默认尝试查询index
      var indexUri = basePath + controller + '/index/index';

      if (seajs.hasDefined[indexUri]) {
        moduleArr.push(indexUri);
        action = 'index';
      } else {
        //未指明action，且controller也不曾定义
        if (!controllerId) {
          return _self.tryIframeRouter(controller);
        }
      }
    }

    var _this = this; // iframe 按 businessKey 加载 css 资源

    if (controller === 'iframe' && params[0]) {
      controller = params[0];
    }
    seajs.use(moduleArr, renderModule);

    var self = this;

    function renderModule(controllerModule, actionModule) {
      _self.renderView(controllerModule);
    }
  },
  //需要确定render到哪个节点上appArea
  renderView: function (actionModule) {
    var self = this;
    // 如果导出的 render 不是函数，则无法渲染
    if (typeof actionModule.render === 'function') {
      try {
        var result = actionModule.render.apply(actionModule, []);
        if (result === 404) {
          self.render404();
        }
      } catch (error) {
        self.renderOops('render-error', error);
      }
    }
    // 导出了奇怪的 render，Oops 告警
    else {
      self.renderOops(
        'render-not-function',
        new Error(
          '模块导出的 render 不是 function, 而是 ' + typeof actionModule.render
        )
      );
    }
  },
  render404: function () { },
  renderOops: function (type, msg) {
    console.log(type, msg);
  }
};

export { pageManager };
